import { useContext, useEffect, useRef, useState } from "react";
import { fakeTableList, infoHeadTitleList, schema } from "./parts";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { Box } from "@mui/material";
import { httpAPI_APP016, httpAPI_RET008 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkMemo from "../../components/molecules/TkMemo";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { BusinessContext } from "../../context/businessContext";
import _ from "lodash";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import {
  isStatusAfterApproval,
  toNumberOrUndefined,
} from "../../utils/useTools";
import TkBackButton from "../../components/molecules/TkBackButton";
import {
  applyEvent,
  CommonOrCommonRetirementFlug,
  Status,
} from "../../assets/data/Constants";
import "./_style.scss";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW410006 退職手当金の請求手続き（請求者情報の登録）
 * @return SCRW410006 退職手当金の請求手続き（請求者情報の登録）
 */
const SCRW410006 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [stateFinancialInfoList, setStateFinancialInfoList] = useState<any>([]);
  const stateFakeTableListRef = useRef(_.cloneDeep(fakeTableList));
  const [statusInfoTableList, setStatusInfoTableList] = useState<any>([]);
  const [bodyList, setBodyList] = useState<any>([]);
  const { state: businessState } = useContext(BusinessContext);
  const { state, setState } = useContext(GlobalContext);
  const contractorNo =
    businessState.common?.contractorNo || location.state?.contractorNo;
  const applyId = location.state?.applyId;
  const [isSubmitOpen, setIsSubmitOpen] = useState(false);
  const [memo, setMemo] = useState("");
  const [status, setStatus] = useState<ITkViewButtonJudgementStatus>();
  const [isApplyCodeChecked, setIsApplyCodeChecked] = useState<boolean>(false);

  // 初期表示
  const handleInit = async () => {
    try {
      let resArr = stateFakeTableListRef.current;
      const res = await httpAPI_RET008({
        contractorNo,
        applyId,
      });

      if (res.resultCd === "I0000") {
        for (let i in res) {
          let targetObj = resArr.find((item) => item.keyword === i)!;
          targetObj && (targetObj.setDefaultValue = res[i as keyof typeof res]);
          if (targetObj?.type === "text") {
            targetObj && (targetObj.text = res[i as keyof typeof res]);
          }
        }

        res.applyRelatedList?.forEach((item) => {
          let targetObj = resArr.find((i) => i.id === item.formClass)!;
          if (targetObj) {
            targetObj.dataname = item.formName;
            targetObj.base64filedata = item.file;
          }
        });

        if (businessState.common?.businessType === "JOB-70") {
          let first = resArr.find((i) => i.keyword === "break")!;
          let last = resArr.find((i) => i.keyword === "changedNameDocument")!;
          resArr
            .filter(
              (_, index) =>
                index >= resArr.indexOf(first) && index <= resArr.indexOf(last)
            )!
            .forEach((item) => (item.showLine = false));
        }
        setStateFinancialInfoList([...resArr]);

        const memoList = res.memoList?.map((memo) => [
          {
            children: memo.managerName,
          },
          {
            children: memo.process,
          },
          {
            children: memo.createDate,
          },
          {
            children: memo.processComment,
          },
        ]);
        setStatusInfoTableList(memoList ?? []);

        let bodyList = [
          [{ children: res.approvalDate }, { children: res.symbolNo }],
        ];
        setBodyList(bodyList);

        setStatus(res.latestApplyStatus as ITkViewButtonJudgementStatus);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 申請状態変更（承認以外）
  const onUpdateApplyStatus = async (applyEventType: string) => {
    try {
      const param = {
        applyId: toNumberOrUndefined(applyId),
        applyEvent: applyEventType,
        reason: memo,
        inquiryCode: isApplyCodeChecked ? "3" : "",
        contractorNo: state.authInfo?.contractorNo ?? contractorNo,
        screenId: applyEventType === "11" ? "SCRW410006" : undefined,
      };
      const res = await httpAPI_APP016(param);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 申請状態変更（承認）
  const handleSubmitChange = async (data: any) => {
    try {
      const symbolType = TkGetCode(
        CommonOrCommonRetirementFlug,
        data?.symbolNumberType
      );
      const symbolText = symbolType + "第" + data?.symbolNumber + "号";
      const param = {
        applyId: toNumberOrUndefined(applyId),
        applyEvent: applyEvent["承認"],
        decisionDate: data?.settlementDate,
        symbolNo: symbolText,
        reason: memo,
        inquiryCode: isApplyCodeChecked ? "3" : "",
      };
      const res = await httpAPI_APP016(param);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setIsSubmitOpen(false);
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 処理ボタンクリック
  const onCheckAndSubmit = (item: keyof typeof applyEvent) => {
    const event = applyEvent[item];
    switch (event) {
      case applyEvent["受理"]:
      case applyEvent["契約者に差戻し"]:
      case applyEvent["課長代理確認"]:
      case applyEvent["上長承認"]:
      case applyEvent["担当者に差戻し"]:
      case applyEvent["郵送"]:
        onUpdateApplyStatus(event);
        break;
      case applyEvent["承認"]:
        setIsSubmitOpen(true);
        break;
      case applyEvent["通知"]:
        navigate("/SCRW130001", {
          state: {
            applyId: applyId,
            contractorNo: contractorNo,
            refInquiryScreen: isApplyCodeChecked ? "1" : undefined,
            screenId: "SCRW410006",
            memo: memo,
          },
        });
    }
  };

  // ダイアログを閉じる
  const handleDialogClose = () => {
    setIsSubmitOpen(false);
  };

  // メモ、チェックボックス入力値変更
  const handleChangeData = (data: any) => {
    if (data?.target?.type === "input") {
      setMemo(data?.target?.value);
    } else {
      setIsApplyCodeChecked(data?.target?.type);
    }
  };

  const isWorkFlow =
    status !== Status["届出待ち"] && status !== Status["差戻し一時保存"];

  return (
    <Box className="SCRW410006" data-testid="SCRW410006PageForTest">
      {isWorkFlow && (
        <TkKikoStepper
          applicationFlowType={"TYPE2"}
          businessType={"JOB-39"}
          applicationStatus={status}
        />
      )}
      <TkFakeTable
        list={stateFinancialInfoList}
        ruleSchema={schema}
        showButton={false}
      />

      {/* メモ、コメント、チェックボックス */}
      <TkMemo bodyList={statusInfoTableList} onChange={handleChangeData} />
      {isStatusAfterApproval(status) && (
        <TkTableWithNoLine headList={infoHeadTitleList} bodyList={bodyList} />
      )}

      <Box className="buttonGroup">
        <TkBackButton mr />
        {isWorkFlow && (
          <TkViewButtonJudgement
            flowType={"TYPE2"}
            Status={status}
            businessType={businessState.common?.businessType}
            onClick={onCheckAndSubmit}
          />
        )}
      </Box>
      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isSubmitOpen}
        onSuccess={handleSubmitChange}
        onClose={handleDialogClose}
      />
    </Box>
  );
};

export default SCRW410006;
